import type { ProjectV1Hook, ProjectV2Hook } from './types/project.type';
import { BaseHookResult, createVersionedHook } from './utils/createVersionHooks';
import { useProjectV1 } from './v1';
import { useProjectV2 } from './v2/useProjectV2';

interface UseProjectV1 extends ProjectV1Hook, BaseHookResult {}
interface UseProjectV2 extends ProjectV2Hook, BaseHookResult {}

export const useProject = createVersionedHook<UseProjectV1 | UseProjectV2>(
  {
    v1: useProjectV1,
    v2: useProjectV2,
  },
  'useProject',
);
